module.exports = __webpack_public_path__ + "img/26.cd23b0f6.png";